import * as React from "react";
import type { SVGProps } from "react";

const FacilityWifi = React.memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    {...props}
  >
    <path
      d="M9.99746 16.0417C9.82496 16.0417 9.68496 16.1817 9.68662 16.3542C9.68579 16.5267 9.82579 16.6667 9.99829 16.6667C10.1708 16.6667 10.3108 16.5267 10.3108 16.3542C10.3108 16.1817 10.1708 16.0417 9.99746 16.0417"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.82422 9.99992C7.23422 6.87242 12.7617 6.87242 16.1717 9.99992"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.32812 6.50301C6.11729 2.27634 13.8823 2.27634 18.6715 6.50301"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.31641 13.1845C8.35057 11.1612 11.6497 11.1612 13.6839 13.1845"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
FacilityWifi.displayName = "FacilityWifi";

export default FacilityWifi;
